import { UniRequest } from '@uniframe/toolkit';
import { get as getToken, remove as removeToken } from '@/utils/token';
import { reportError, report } from '@/utils/monitor';
import { useComplianceWall } from '@/hooks/compliance';

const { showComplianceWall } = useComplianceWall();

// const { isApp } = window?.sfe;

const uniRequest = new UniRequest({
    credentials: 'include',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        // platform: isApp ? 'h5' : 'pc',
        platform: 'pc',
    },
});

uniRequest.addInstanceRequestInterceptors([
    async (url, options) => {
        // 此处获取token是为H5中webview使用，pc端不再使用
        const token = await getToken(true);
        if (token) {
            // TODO usertoken 这个key 有啥要求没
            options.headers.usertoken = token;
        }
        return {
            url,
            options,
        };
    },
]);

uniRequest.addInstanceResponseInterceptors([
    async (response, _, operations) => {
        // always clone the response before working on it
        try {
            const clonedResponse = response.clone();
            const data = await clonedResponse.json();

            if (!data) {
                return Promise.reject(
                    operations.createResponseError('Non Response!', undefined),
                );
            }

            // 登录状态有啥问题时直接跳转到登录页
            if ([10007, 33003, 10009, 30000].includes(data.ret_code)) {
                if (!response?.url?.includes?.('/v2/private/user/profile')) {
                    operations.clearOneCache();
                }
                removeToken();
            }

            // 合规墙 - （用户没有KYC || 本地区不支持此服务）就弹出相关弹窗
            if (data.ret_code === 10024) {
                const { ret_code: retCode, result } = data;
                // 阻止toast弹出信息
                data.message = '';
                showComplianceWall(retCode, result);
            }

            return response;
        } catch (err) {
            return Promise.reject(err);
        }
    },
]);

export {
    uniRequest,
};
